<template>
  <div>
    <transition name="fade">
      <div v-for="(message, i) in alerts.messages" :key="i"
        :class="formStyles()"
        role="alert">

        <span v-html="message"></span>

        <button
          type="button"
          class="close" data-dismiss="alert" aria-label="Close"
          @click.stop="closeAlert()">
          <span aria-hidden="true">&times;</span>
        </button>

      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      timeoutId: null,
    };
  },
  computed: {
    alerts() {
      return this.$store.getters.alerts;
    },
  },
  methods: {
    closeAlert() {
      this.$store.commit('updateAlerts', {
        messages: [],
        variant: '',
      });
    },
    formStyles() {
      const style = ['alert'];

      switch (this.alerts.variant) {
        case 'success':
          style.push('alert-success');
          break;

        case 'warning':
          style.push('alert-warning');
          break;

        case 'danger':
          style.push('alert-danger');
          break;

        default:
          break;
      }

      return style;
    },
    removeAlertMessages() {
      this.timeoutId = setTimeout(() => {
        this.closeAlert();
      }, 10000); // TODO: Use config value
    },
  },
  watch: {
    alerts: function alerts() {
      if (this.alerts.messages && this.alerts.messages.length) {
        clearTimeout(this.timeoutId);
        this.removeAlertMessages();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/presentational/alerts/SectionAlerts.vue?e4495afa